module.exports = __webpack_public_path__ + "static/media/twitterArticle.9915cf35.svg";